"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _transformUrlsWithOverrides = require("./transformUrlsWithOverrides");
Object.keys(_transformUrlsWithOverrides).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _transformUrlsWithOverrides[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _transformUrlsWithOverrides[key];
    }
  });
});
//# sourceMappingURL=index.js.map